import { render, staticRenderFns } from "./SafeGuard.vue?vue&type=template&id=67ade196&scoped=true&"
import script from "./SafeGuard.vue?vue&type=script&lang=js&"
export * from "./SafeGuard.vue?vue&type=script&lang=js&"
import style0 from "./SafeGuard.vue?vue&type=style&index=0&id=67ade196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ade196",
  null
  
)

export default component.exports